<template>

  <div
    class="modal fade"
    id="paymentDataModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="paymentDataModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">
            {{ paymentLbl }} Data
          </h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <modal-flash></modal-flash>
          <modal-spinner
            size="large"
            v-if="loading"
          />
          <div
            class="payments"
          >
            <div
              class="payment"
              v-for="payment in payments"
            >
              <h4>
                Transaction
                <button
                  type="submit"
                  class="btn btn-warning btn-sm ml-1"
                  v-on:click.prevent="setTransaction(payment)"
                  v-if="isExternalPurchase"
                >
                  Set Transaction
                  <modal-spinner size="small" v-if="loading"></modal-spinner>
                </button>
              </h4>
              <table
                :class="'table' + (payment.transaction_id === purchase.external_payment_sale_id ? ' active-payment' : '')"
              >
                <tr>
                  <td>
                    Transaction ID
                  </td>
                  <td>
                    {{ payment.transaction_id }}
                  </td>
                </tr>
                <tr>
                  <td>
                    Status
                  </td>
                  <td>
                    {{ payment.status }}
                  </td>
                </tr>
                <tr>
                  <td>
                    Transaction Type
                  </td>
                  <td>
                    {{ payment.transaction_type }}
                  </td>
                </tr>
                <tr>
                  <td>
                    Payer Email
                  </td>
                  <td>
                    {{ payment.payer_email }}
                  </td>
                </tr>
                <tr>
                  <td>
                    Payer Name
                  </td>
                  <td>
                    {{ payment.payer_name }}
                  </td>
                </tr>
                <tr>
                  <td>
                    Transaction Time
                  </td>
                  <td>
                    {{ payment.time_stamp }} {{ payment.time_zone }}
                  </td>
                </tr>

                <tr
                  v-if="payment.amount"
                >
                  <td>
                    Amount
                  </td>
                  <td>
                    {{ payment.amount.value }} {{ payment.amount.currency }}
                  </td>
                </tr>
                <tr
                  v-if="payment.fee_amount"
                >
                  <td>
                    Fee Amount
                  </td>
                  <td>
                    {{ payment.fee_amount.value }} {{ payment.fee_amount.currency }}
                  </td>
                </tr>
                <tr
                  v-if="payment.net_amount"
                >
                  <td>
                    Net Amount
                  </td>
                  <td>
                    {{ payment.net_amount.value }} {{ payment.net_amount.currency }}
                  </td>
                </tr>
              </table>
            </div>
            <vue-json-pretty
              :data="paymentJSON"
              v-if="paymentJSON"
            />
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">
            Close
          </button>
          <!--
          <button type="button" class="btn btn-primary">
            Save To Record
          </button>
          -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Spinner from 'vue-simple-spinner'
import VueJsonPretty from 'vue-json-pretty'

import Flash from '@/components/Flash'

import FlashStore from '@/stores/FlashStore'
import PurchaseStore from '@/stores/PurchaseStore'

export default {
  components: {
    'modal-flash': Flash,
    'modal-spinner': Spinner,
    'vue-json-pretty': VueJsonPretty
  },

  props: {
    purchaseId: {
      type: String,
      default: undefined
    }
  },

  data () {
    return {
      loading: false,
      paymentJSON: undefined,
      payments: [],
      purchase: PurchaseStore.state
    }
  },

  // These should be moved to a purchase helper.
  computed: {
    isExternalPurchase () {
      return this.purchase.external_payment_id || this.purchase.external_payment_sale_id
    },

    isRecurringPurchase () {
      return this.purchase.external_payment_subscription_id
    },

    paymentLbl () {
      return (this.isRecurringPurchase ? 'Recurring Payments' : 'Payment')
    }
  },

  mounted () {
    this.$parent.$on('open-payment-data-modal', this.onModelShow)
  },

  methods: {
    get () {
      this.loading = true
      this.paymentJSON = undefined
      this.payments = undefined

      return this.$http.get(
        this.apiUrl(
          '/purchases/' + this.purchaseId + '/payment_data',
          true
        )
      ).then((resp) => {
        if (this.isRecurringPurchase) {
          this.payments = resp.body
          this.paymentJSON = resp.body
        } else {
          this.paymentJSON = resp.body
        }
      }, (resp) => {
        FlashStore.errors(resp.body.errors)
      }).finally(() => {
        this.loading = false
      })
    },

    onModelShow (purchase) {
      FlashStore.clear()
      this.get()
    },

    setTransaction (transaction) {
      if (
        confirm(
          'Are you sure you want to overwrite the current purchase transaction data with this transaction data?'
        )
      ) {
        this.loading = true
        this.$http.put(
          this.apiUrl(
            '/purchases/' + this.purchaseId + '/set_transaction/' + transaction.transaction_id,
            true
          )
        ).then((resp) => {
          this.$parent.$emit('update-purchase', this.processSuccess(resp))
        }, (resp) => {
          FlashStore.errors(resp.body.errors)
        }).finally(() => {
          this.loading = false
        })
      }
    }
  }
}
</script>

<style scoped>
.modal-dialog {
  min-width: 50vw;
  max-height: 80vh;
}

.modal-body {
  max-height: 80vh;
  overflow: auto;
}

.payments td {
  width: 50%;
}

.payments .active-payment {
  background-color: #fffdb3;
}
</style>



// WEBPACK FOOTER //
// src/components/PurchasePaymentsModal.vue